import { infoColor } from "assets/jss/material-dashboard-pro-react";

const wrapperStyle = () => ({
	infoMessageContainer: {
		marginTop: "20px",
		backgroundColor: infoColor[7],
		display: "flex",
		padding: "10px",
		alignItems: "center",
	},
	infoiconWrapper : {
		padding: "10px",
		display: "flex"
	},
	infoicon : {
		transform: 'rotate(180deg)'
	},
	messageWrapper: {
		padding: "10px 10px 10px 0px"
	},
	bodyWrapper:{
		display: 'grid',
		'grid-template-columns': 'auto auto auto',
		gap: '10px'
	}
});

export default wrapperStyle;
